import { Component } from '@angular/core';
import {SignInComponent} from "../../component/sign-in/sign-in.component";

@Component({
  selector: 'app-sign-in-view',
  standalone: true,
  imports: [
    SignInComponent
  ],
  templateUrl: './sign-in-view.component.html',
  styleUrl: './sign-in-view.component.scss'
})
export class SignInViewComponent {

}
